import React, { useEffect, useState, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { InteractionStatus } from "@azure/msal-browser";
 
function LoginPage({ forceLogin = false }) {
  const { instance, accounts, inProgress } = useMsal();
  const navigate = useNavigate();
  const loginAttemptedRef = useRef(false);
 
  useEffect(() => {
    // Handle MSAL redirect response and set active account
    instance.handleRedirectPromise().then((response) => {
      if (response) {
        instance.setActiveAccount(response.account);
      } else if (inProgress === InteractionStatus.None && !loginAttemptedRef.current) {
        // If no response and not in progress, trigger login once
        loginAttemptedRef.current = true;
        instance.loginRedirect().catch((error) => {
          console.error("Login error:", error);
          alert("Login failed: " + (error.message || error));
        });
      }
    });
  }, [instance, inProgress]);
 
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <p>Loading...</p>
    </div>
  );
}
 
export default LoginPage;